import React from 'react';
import MultiStepLayoutHeader from './multi-step-layout-header';

interface LayoutProps {
  headerLeftButton?: boolean;
  headerRightButton?: boolean;
  children: React.ReactNode;
}

const MultiStepLayout = ({ headerLeftButton, headerRightButton, children }: LayoutProps) => {
  return (
    <div className="flex flex-col lg:h-screen">
      <MultiStepLayoutHeader leftButton={headerLeftButton} rightButton={headerRightButton} />
      <main className="flex flex-col py-20 lg:py-32 px-2 mx-auto w-full">{children}</main>
    </div>
  );
};

export default MultiStepLayout;
